function NewAdHocCondition() {
    return {
        id: null,       
        questionToCheck: {},
		validAnswerValues: [],
		negate: 0
      }
}
export default NewAdHocCondition;